
<!-- =========================================================================================
  File Name: AttendeeAdd.vue
  Description: Attendee Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-attendee-add" class="attendee-form-wrap">
    <div class="header-custome">
      <h3>Add Menu</h3>
    </div>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <menu-edit :data="menu_data" />
      </div>
    </vx-card>
  </div>
</template>

<script>
import menuEdit from "./MenuEdit.vue";

// Store Module
import moduleMenuManagement from "@/store/menu-management/moduleMenuManagement.js";

export default {
  components: {
    menuEdit,
  },
  data() {
    return {
      menu_data: null,
    };
  },
  methods: {
    fetchMenus() {
      this.$store
        .dispatch("moduleMenuManagement/fetchMenus", null)
        .then((res) => {
          this.menu_data = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  created() {
    // Register Module attendeeManagement Module
    if (!moduleMenuManagement.isRegistered) {
      this.$store.registerModule("moduleMenuManagement", moduleMenuManagement);
      moduleMenuManagement.isRegistered = true;
    }
    this.fetchMenus();
  },
};
</script>